import styled, { keyframes } from "styled-components";
import { paletas } from "../../styles/theme";

const animaRight = keyframes`
  from {
    margin-left: 50px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    
  }
  50% {
    margin-right: 25px;
    -webkit-transform: rotate(20deg);
    -moz-transform: rotate(20deg);
    -ms-transform: rotate(20deg);
    -o-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  to {
    margin-left: 50px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
`;

const animaLeft = keyframes`
 from {
    margin-right: 50px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    margin-left: 0px;
    -webkit-transform: rotate(20deg);
    -moz-transform: rotate(20deg);
    -ms-transform: rotate(20deg);
    -o-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  to {
    margin-right: 50px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
`;

const animaCenter = keyframes`
  from {
    margin-left: 40vw;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    margin-left: 50vw;
    -webkit-transform: rotate(20deg);
    -moz-transform: rotate(20deg);
    -ms-transform: rotate(20deg);
    -o-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  to {
    margin-left: 40vw;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
`;

const animaAlturaUp = keyframes`
  from {
    height: calc(100vh - 190px);
  }
  to {
    height: calc(100vh - 140px);
  }
`;

const animaAlturaSDown = keyframes`
  from {
    height: calc(100vh - 140px);
  }
  to {
    height: calc(100vh - 190px);
  }
`;

export const Wrapper = styled.main`
  padding: 20px;
  transition: all 1s;

  .aumentaAltura {
    margin-bottom: 0px;
    height: calc(100vh - 110px);
    animation: 1s ${animaAlturaUp} ease;

    @media (min-width: 576px) {
      height: calc(100vh - 140px);
    }
  }

  .diminuiAltura {
    margin-bottom: 15px;
    height: calc(100vh - 160px);
    animation: 1s ${animaAlturaSDown} ease;

    @media (min-width: 576px) {
      height: calc(100vh - 200px);
    }
  }

  .body {
    position: relative;
    color: ${paletas.White};
    font-family: Arial, Helvetica, sans-serif;
    border-radius: 0.25rem;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
    overflow-y: scroll;
    padding: 20px;

    &::-webkit-scrollbar-thumb {
      display: none;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const BgTriangulo = styled.div`
  position: absolute;
  width: 100px;
  height: 100px;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  background: rgba(0, 0, 0, 0.2);
  z-index: -1;
  top: 0;
  left: 0;
  margin-left: 50px;
  margin-top: 70vh;
  animation: 14s ${animaLeft} infinite linear;
`;

export const BgMais = styled.div`
  position: absolute;
  width: 100px;
  height: 100px;
  clip-path: polygon(
    35% 0%,
    65% 0%,
    65% 35%,
    100% 35%,
    100% 60%,
    65% 60%,
    65% 100%,
    35% 100%,
    35% 60%,
    0% 60%,
    0% 35%,
    35% 35%
  );
  background: rgba(0, 0, 0, 0.2);
  z-index: -1;
  animation: 18s ${animaRight} infinite linear;
  top: 0;
  right: 0;
  margin-top: 50px;
  margin-right: 100px;
`;

export const BgRetangulo = styled.div`
  position: absolute;
  width: 150px;
  height: 100px;
  border-radius: 0.25rem;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.25rem;
  z-index: -1;
  top: 0;
  left: 0;
  margin-left: 50vw;
  margin-top: 50vh;
  animation: 24s ${animaCenter} infinite linear;

  @media (max-width: 700px) {
    display: none;
  }
`;

export const BgCirculo = styled.div`
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.25rem;
  z-index: -1;
  top: 0;
  right: 0;
  margin-right: 50px;
  margin-top: 60vh;
  animation: 28s ${animaRight} infinite linear;

  @media (max-width: 700px) {
    display: none;
  }
`;

export const BgQuadrado = styled.div`
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 0.25rem;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.25rem;
  z-index: -1;
  top: 0;
  left: 0;
  margin-left: 50px;
  margin-bottom: 100px;
  animation: 32s ${animaLeft} infinite linear;

  @media (max-width: 700px) {
    display: none;
  }
`;
